export default __webpack_public_path__ + "static/media/icon-ibk@3x.9cf89f88.png";